import { format, parse } from 'date-fns'

export const formatDate = (stringDate: string) => {
	if (stringDate) {
		const parsedDate = parse(stringDate, "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'", new Date())
		const formattedDate = format(parsedDate, 'dd. MM. yyyy')
		return formattedDate
	}
}
